// extracted by mini-css-extract-plugin
export default {"sapcnqr-badge":"sapcnqr-badge-e4113d"};